  import { createReducer, on, union } from '@ngrx/store';
  import { CourseState } from './course.state';
  import { ICourse } from '../models/course.model';
import { courseActions } from './course.actions';

  export const initialCourseState: CourseState = {
    currentCourse: {} as ICourse,
    courseList: [] as ICourse[]
  };

  export const courseReducer = createReducer(
    initialCourseState,

    on(courseActions.getCoursesSuccess, (state, { courseList }) => ({
        ...state,
        courseList: courseList
      })
    ),

    on(courseActions.getCourseSuccess, (state, { course }) => ({
        ...state,
        currentCourse: course
      })
    ),

  )


